import { ModalIsland, Typography } from "@saviynt/design-system";
import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";

import { DUPLICATE_TICKET_ERROR } from "../ActionButton/ActionButton";

interface TicketErrorModalProps {
  data: { message: string; error_code?: string };
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export default function TicketErrorModal({
  data,
  isOpen,
  setIsOpen,
}: TicketErrorModalProps) {
  const intl = useIntl();
  const { message, error_code = "" } = data;

  const getTitleByErrorCode = () => {
    if (error_code === DUPLICATE_TICKET_ERROR) {
      return intl.formatMessage({
        description: "Modal Title",
        defaultMessage: "Ticket already exists",
        id: "cvPapJ",
      });
    }
    if (error_code === "DUPLICATE_ENTRY") {
      return intl.formatMessage({
        description: "Modal Title",
        defaultMessage: "Remediation Request already exists.",
        id: "Pr3DWq",
      });
    }
    return "";
  };

  const title = getTitleByErrorCode();

  return (
    <ModalIsland
      kind="question"
      HeaderComp={
        <>
          <Typography kind="h2" className="text-center">
            {title}
          </Typography>
          <Typography kind="body2" className="text-center">
            {message}
          </Typography>
        </>
      }
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      isOutsideClickEnabled
    />
  );
}
